import { getLanguage, t } from 'react-switch-lang';
import { Container, Row } from 'react-bootstrap';
import { useEffect } from 'react';
import MainLayout from '../../components/MainLayout';
import SectionTitle from '../../components/SectionTitle';
import styles from '../../styles/TermsAndConditions.module.scss';
import { events, logAmpEvent } from '../../utils/Amplitude';

export default function TermsAndCondition() {
  const lang = getLanguage();
  const docID = {
    en: '2PACX-1vR1ICp1r5-qS8k2QRj6RSEoa_NutJLnBSkKDsSTq27clhuwV1refuozS7RY7rZaqjruY9e-Ym3Dhiwv',
    fr: '2PACX-1vTCYmPs7kMIbHUk9TBGdxoepk4BK89DpCpChlA_amyE5LdC8gPlUW_ocIwKP02QQcgBDUFmb_ALoaPt',
  };

  useEffect(() => {
    logAmpEvent(
      events.USER_VIEWED_TERMS_AND_CONDITIONS_PAGE,
      { Language: lang }
    );
  }, [lang]);
  return (
    <MainLayout title={t('PageTitle_TermsAndConditions')}>
      <Container fluid="xxl">
        <Row className={styles.headingRow}>
          <SectionTitle title={t('TermsAndConditions_Heading_Title')}>
            <p className={styles.headingSubTitle}>{t('TermsAndCondition_Heading_SubTitle')}</p>
          </SectionTitle>
        </Row>
        <Row>
          <div className={styles.iframeContainer}>
            <iframe title={t('PageTitle_TermsAndConditions')} src={`https://docs.google.com/document/d/e/${docID[lang]}/pub?embedded=true`} border="0" cellSpacing="0" />
          </div>
        </Row>
      </Container>
    </MainLayout>
  );
}
